import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './css/style.css'
import './index.scss'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'react-phone-input-2/lib/style.css'
import 'font-awesome/css/font-awesome.min.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
